import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { MediaTile } from "@/components/MediaTile";
import { MediaLightbox } from "@/components/MediaLightbox";
import { api } from "@/lib/api";
import { Loader2, Layers } from "lucide-react";

const GalleryPage = () => {
  const { gid } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get(`/galleries/${gid}`).then((r) => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, [gid]);

  if (loading) return <div className="min-h-screen relative z-10"><Navbar /><div className="flex justify-center py-40"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div></div>;
  if (!data) return <div className="min-h-screen relative z-10"><Navbar /><div className="text-center py-40 text-muted-foreground">Gallery not found.</div></div>;

  return (
    <div className="min-h-screen relative z-10">
      <Navbar />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-10">
        <button onClick={() => navigate("/browse")} className="text-sm text-primary hover:underline mb-3">← Back to browse</button>
        <div className="flex items-center gap-2 text-primary"><Layers className="w-5 h-5" /><span className="text-xs tracking-[0.2em] uppercase font-bold">Gallery</span></div>
        <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tighter mt-1">{data.name}</h1>
        <p className="text-muted-foreground mt-2">{data.count} {data.count === 1 ? "item" : "items"}</p>
        {data.items.length === 0 ? (
          <div className="border border-dashed border-border rounded-xl py-16 text-center text-muted-foreground mt-8">This gallery is empty.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 mt-8">
            {data.items.map((m, i) => <MediaTile key={m.id} item={m} index={i} onOpen={(x) => setSelected(x.id)} />)}
          </div>
        )}
      </div>
      <MediaLightbox mediaId={selected} open={!!selected} onClose={() => setSelected(null)} onNavigate={setSelected} playlist={data.items} />
    </div>
  );
};

export default GalleryPage;
